import vmClient from 'app/services/vmClient';
import { AuthProvider, AuthProviderMarshaller } from 'app/constants/enums/AuthProvider';
import { Entity, EntityStringId, IEntityType } from 'app/types/entity';
import { Configuration, IConfiguration } from './Configuration';
import { ALL_TRANSLATIONS } from '../translations';

export interface IUsersConfig extends IConfiguration {
  attributes: {
    id: EntityStringId;
    externalUserProfileUrl: string | null;
    /**
     * The collection of supported authentication methods for this brand.
     */
    authProviders: AuthProvider[];
  }
}

export type UsersConfig = Entity<IUsersConfig>;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersConfig: IEntityType<IUsersConfig> = vmClient.defineClass({
  typeName: 'SiteFeature.UsersConfig',
  version: 1,
  persisted: true,
  extends: Configuration,
  attributes: {
    externalUserProfileUrl: 'string',
    authProviders: {
      type: AuthProvider,
      marshaller: AuthProviderMarshaller,
      notNull: true,
      collection: true,
    },
  },
});

ALL_TRANSLATIONS.set(UsersConfig, {
  authProviders: {
    getLabel: (t) => t('entity-fields.UsersConfig.authProviders.label'),
  },
  externalUserProfileUrl: {
    getLabel: (t) => t('entity-fields.UsersConfig.externalUserProfileUrl.label'),
    getDescription: (t) => t('entity-fields.UsersConfig.externalUserProfileUrl.description'),
  },
});
